export enum SnackbarTypes {
  add = 'add',
  delete = 'delete',
  duplicate = 'duplicate',
  update = 'update',
  error = 'error',
  errorUserNotFound = 'errorUserNotFound',
  errorUploadLogo = 'erroruploadlogo',
  share = 'share',
  publish = 'publish',
  addFavorite = 'addFavorite',
  deleteFavorite = 'deleteFavorite',
  mailReinitPasswordSend = 'mailReinitPasswordSend',
  mailInitSend = 'mailInitSend',
  mailSend = 'mailSend',
  compositionUpdate = 'compositionUpdate',
  projectAgencyOwner = 'projectAgencyOwner',
  reject = 'reject',
  accountActivated = 'accountActivated',
  noEcoProAccount = 'noEcoProAccount',
  indicatorRequiert = 'indicatorRequiert',
  massRequired = 'massRequired',
  resetPasswordTokenExpired = 'resetPasswordTokenExpired',
  differentSolutionVersionId = 'differentSolutionVersionId',
  shareProject = 'shareProject',
  VersionProject = 'VersionProject',
  VersionProjectCheck = 'VersionProjectCheck',
  ResourceNotAvailableForversion = 'ResourceNotAvailableForversion,',
  ResourceUFNotAvailableForversion = 'ResourceUFNotAvailableForversion,'
}
